import Button from '@/common/components/Button'
import { useReactFlow } from '@xyflow/react'
import { ZoomInIcon, ZoomOutIcon } from 'lucide-react'

export const ZoomButtons = () => {
  const { zoomIn, zoomOut } = useReactFlow()

  return (
    <div className="flex items-center gap-x-3 mr-1">
      <Button
        variant="link-white"
        className="size-7 bg-white-200 rounded-full"
        onClick={() => zoomOut({ duration: 250 })}
      >
        <ZoomOutIcon className="size-4" />
      </Button>

      <Button
        variant="link-white"
        className="size-7 bg-white-200 rounded-full"
        onClick={() => zoomIn({ duration: 250 })}
      >
        <ZoomInIcon className="size-4" />
      </Button>
    </div>
  )
}
